import React from "react";
import place from "../../../assets/images/footer/place.svg";
import phone from "../../../assets/images/footer/phone.svg";
import mail from "../../../assets/images/footer/email.svg";
import { SocialIcon } from 'react-social-icons'
import "./Footer.scss";

const Footer = ({ admin }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {!admin && (
        <footer>
          <div className="location">
            <div className="footer-title">Location</div>
            <div>
              <div className="flex-align-center margin-bottom-10">
                <img src={place} alt="phone icon" />
                <div>Worldwide via zoom</div>
              </div>
              <div className="flex-align-center margin-bottom-10">
                <img src={phone} alt="phone icon" />
                <div>1-866-RATH101 (1-866-728-4101)</div>
              </div>
              <div className="flex-align-center">
                <img src={mail} alt="email icon" />
                <div>info@rathtutoring.com</div>
              </div>
            </div>
          </div>
          
          <div className="hours">
            <div className="footer-title">Office hours</div>
            <div>
              <div>10am - 6pm ET/PT</div>
              <div>Evenings and Weekends by Appointment</div>
            </div>
          </div>

          <div className="join">
            <div className="footer-title">Join our team</div>
            <div className="desktop">
              <div>
                Rath Tutoring is continually looking for the most
                experienced and professional talent in higher education to add
                to our team.
              </div>
              <a
                className="submit-application"
                href="mailto: admin@rathtutoring.com?subject=Application"
              >
                Submit an application
              </a>
            </div>
            <span className="mobile">
              Rath Tutoring is continually looking for the most
              experienced and professional talent in higher education to add to
              our team.
              <a
                className="submit-application"
                href="mailto: admin@rathtutoring.com?subject=Application"
              >
                Submit an application
              </a>
            </span>
          </div>

          <div className="copyright">
            <div className="blog-link">Read the latest updates on our <a href="/news">BLOG</a></div>
            <div>Copyright © Rath Tutoring {currentYear}</div>
            <div>
              ACT, AP, GMAT, GRE, HSPT, IB, ISEE, LSAT, MCAT, PSAT, SAT, SSAT,
              and TOEFL are registered trademarks not owned by Rath Tutoring.{" "}
            </div>
            <div>
              The trademark holders were not involved in the production of, and
              do not endorse, this website.
            </div>
            <div className='social-media-icons'>
              <SocialIcon target="_blank" url="https://www.linkedin.com/company/rath-tutoring" />
              <SocialIcon target="_blank" url="https://x.com/RathTutoring" />
              <SocialIcon target="_blank" url="https://www.facebook.com/rathtutoring/" />
              <SocialIcon target="_blank" url="https://www.instagram.com/rathtutoring" />
              <SocialIcon target="_blank" url="https://www.youtube.com/@Rath-Tutoring" />
              <SocialIcon target="_blank" url="http://www.tiktok.com/@rathtutoring" />
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
